export default function convertB2ToS3StyleUrl(b2Url, region = "us-east-005") {
  if (!b2Url || !b2Url.includes("backblazeb2.com")) return b2Url;

  try {
    const url = new URL(b2Url);

    // Extract the path after `/file/`
    const match = url.pathname.match(/^\/file\/([^\/]+)\/(.+)$/);
    if (!match) return b2Url;

    const bucket = match[1];
    const filePath = match[2];

    return `https://${bucket}.s3.${region}.backblazeb2.com/${filePath}`;
  } catch (e) {
    console.error("Invalid URL:", b2Url);
    return b2Url;
  }
}
